import React, { Fragment, useState } from "react";
import ModalVideo from "react-modal-video";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/ser-01.svg";
import sImg1 from "../../images/icon/sd-icon01.svg";
import sImg2 from "../../images/icon/sd-icon02.svg";
import sImg3 from "../../images/icon/sd-icon03.svg";
import sImg4 from "../../images/icon/sd-icon04.svg";
import shape from "../../images/shape/sd-shape.png";
import sicon from "../../images/icon/check-icon.svg";
import bannerFirewall from "../../images/banners/banner_firewall.png";

const FirewallComodatoPage = (props) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Fragment>
      <div className="sco_agency">
        <Header2 />
        <main className="page_content service-single-page">
          <section
            className="page-title pt-200 pos-rel bg_img"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            <div className="container">
              <div className="page-title-wrap sd-title-wrap">
                <div className="row mt-none-30 align-items-center justify-content-center">
                  <div className="col-lg-10 col-xl-8 mt-30">
                    <div className="page-title-box">
                      <span className="sub-title">
                        <img src={icon} alt="" /> Firewall Comodato
                      </span>
                      <h2 className="title">
                        Segurança de rede empresarial <br /> gerenciada com
                        equipamentos <br /> de última geração
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="video pt-70 pb-65">
            <div className="container">
              <div className="xb-video sd-video image-only pos-rel">
                <img src={bannerFirewall} alt="Firewall Banner" />
              </div>
            </div>
          </div>
          <div className="sd-ser-content_wrap pb-110">
            <div className="container">
              <div className="sd-ser-content">
                <h2 className="sd-title">
                  Firewall Comodato Somar: Segurança Empresarial Inteligente
                </h2>
                <p className="sd-content">
                  O Firewall Comodato da Somar Cloud oferece proteção de rede de
                  nível empresarial através de equipamentos Fortinet FortiGate
                  de última geração fornecidos em regime de comodato, eliminando
                  investimentos iniciais em hardware. Nossa solução combina
                  hardware dedicado com gestão especializada 24/7,
                  proporcionando segurança máxima contra ameaças avançadas,
                  malware, ransomware e ataques DDoS.
                </p>
                <br />
                <p className="sd-content">
                  Com tecnologia de inspeção profunda de pacotes (DPI),
                  inteligência artificial para detecção de ameaças, e
                  atualizações automáticas de assinaturas, nossos firewalls
                  FortiGate oferecem proteção proativa contra ameaças zero-day.
                  Incluímos VPN site-to-site, controle de aplicações, filtragem
                  web avançada, e relatórios detalhados de segurança com
                  dashboards em tempo real.
                </p>
                <br />
                <p className="sd-content">
                  <strong>Vantagens exclusivas Somar:</strong> Equipamentos
                  Fortinet inclusos sem CAPEX, configuração e gestão
                  especializada, monitoramento 24/7 por nossa equipe de
                  segurança, updates automáticos de firmware e assinaturas,
                  suporte técnico imediato, e substituição de hardware em caso
                  de falha. Proteja sua empresa com segurança de nível
                  corporativo sem investimentos iniciais.
                </p>
              </div>
            </div>
          </div>
          <div className="sd-process_warp">
            <div className="container">
              <div className="sd-heading">
                <h2 className="sd-title">Implementação de Segurança</h2>
                <p className="sd-content">
                  Nossa metodologia de implementação de firewall garante
                  proteção imediata com configurações otimizadas para seu
                  ambiente específico.
                </p>
              </div>
              <div className="sd-process_inner ul_li">
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg1} alt="" />
                  </div>
                  <h3 className="xb-item--title">Análise de Segurança</h3>
                  <p className="xb-item--contact">
                    Avaliação completa de vulnerabilidades e requisitos de
                    proteção.
                  </p>
                  <span className="xb-item--number">01</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg2} alt="" />
                  </div>
                  <h3 className="xb-item--title">Configuração Especializada</h3>
                  <p className="xb-item--contact">
                    Setup personalizado de regras e políticas de segurança.
                  </p>
                  <span className="xb-item--number">02</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg3} alt="" />
                  </div>
                  <h3 className="xb-item--title">Deploy e Ativação</h3>
                  <p className="xb-item--contact">
                    Instalação e ativação com testes de penetração.
                  </p>
                  <span className="xb-item--number">03</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg4} alt="" />
                  </div>
                  <h3 className="xb-item--title">Monitoramento Contínuo</h3>
                  <p className="xb-item--contact">
                    Gestão 24/7 com resposta automática a incidentes.
                  </p>
                  <span className="xb-item--number">04</span>
                </div>
                <div className="sd-shape">
                  <img src={shape} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sd-service_wrap pt-115 pb-130">
            <div className="container">
              <div className="sd-ser-outcome">
                <div className="sd-heading">
                  <h2 className="sd-title">Benefícios do Firewall Comodato</h2>
                  <p className="sd-content">
                    Proteja sua empresa com segurança de nível corporativo
                    através de equipamentos dedicados e gestão especializada,
                    sem investimentos iniciais.
                  </p>
                </div>
                <div className="sd-list-item ul_li">
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Equipamentos Fortinet FortiGate inclusos
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Inspeção profunda de pacotes (DPI)
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Proteção contra ameaças zero-day
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      VPN site-to-site e controle de aplicações
                    </li>
                  </ul>
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Monitoramento e gestão 24/7
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Updates automáticos de segurança
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Relatórios detalhados em tempo real
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Substituição de hardware sem custo
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="7e90gBu4pas"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};

export default FirewallComodatoPage;
